// extracted by mini-css-extract-plugin
export default {"input":"_9MAJR","checkedCheckbox":"_0qveF","wrapper":"TN81o","checkbox":"AYLQD","policy":"NwFM9","labelContainer":"_62Xfq","checkboxLabel":"_2yWdl","checkboxWrapper":"HIz8f"};